export default __webpack_public_path__ + "static/media/angular-logo.5ec6978d.svg";